<template>
  <v-form
    :data="data"
    :url="route"
    method="patch"
    @success="onSuccess()"
  >
    <div class="pt-6" />
    <div class="card relative mb-8">
      <div class="-top-8 left-1/2 absolute inline-flex items-center justify-center w-16 h-16 mx-auto text-center -translate-x-1/2 bg-white rounded-full shadow">
        <img
          :src="icon"
          alt="icon"
        >
      </div>

      <div class="sm:pt-4 pt-6" />

      <slot />
    </div>

    <div class="md:flex md:space-x-3 md:space-y-0 w-full space-y-3">
      <button
        v-if="previous"
        type="button"
        class="btn btn-white-outline grow w-full"
        @click="goBack"
      >
        Previous
      </button>
      <button
        type="submit"
        class="btn btn-primary grow w-full"
      >
        Continue
      </button>
    </div>
  </v-form>
</template>
<script>
export default {
  name: "v-quiz-fly",
  props: {
    route: {
      required: true,
      type: String
    },
    icon: {
      required: true,
      type: String
    },
    data: {
      required: true,
      type: Object
    },
    previous: {
      default: "",
      type: String
    },
    next: {
      required: true,
      type: String
    },
    refreshOnSuccess: {
      default: false,
      type: Boolean
    },
    refreshWithTarget: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      form: {
        quiz_fly: 0
      }
    };
  },
  methods: {
    goBack() {
      this.$router.push({name: this.previous});
    },
    onSuccess() {
      if (this.refreshWithTarget != null) {
        window.location.href = "/app/"+this.refreshWithTarget;
        return;
      }
      if (this.refreshOnSuccess) {
        window.location.href="/app";
        return;
      }
      this.$router.push({name: this.next});
    }
  },
};
</script>
